import { Suspense } from 'react';
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/AppSidebar';
import { BottomNav } from '@/components/BottomNav';
import { DarkModeToggle } from '@/components/DarkModeToggle';
import { NotificationBell } from '@/components/NotificationBell';
import { useLocation, Navigate } from 'react-router-dom';
import { isPageHidden, useUiConfig } from '@/lib/uiConfig';
import { useAdminRole } from '@/hooks/useAdminRole';
import logoSmall from '@/assets/isc-logo-small.webp';
import { useAppChrome } from '@/store/appChrome';
import { PopupQuiz } from '@/components/PopupQuiz';
const logoAsset = { url: logoSmall };

function PageGate({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const ui = useUiConfig();
  const { isAdmin } = useAdminRole();
  if (!isAdmin && isPageHidden(ui, pathname)) return <Navigate to="/" replace />;
  return <>{children}</>;
}

export function AppLayout({ children }: { children: React.ReactNode }) {
  const hideBottomNav = useAppChrome((s) => s.hideBottomNav);
  return (
    <SidebarProvider>
      <div className="h-[100dvh] flex w-full overflow-hidden">
        <AppSidebar />
        <div className="flex-1 flex flex-col min-w-0 h-full">
          <header className="h-16 shrink-0 border-b border-border bg-card z-50 shadow-card">
            <div className="h-full w-full max-w-[1400px] mx-auto flex items-center px-3 sm:px-4 md:px-6 lg:px-8 gap-3">
              <SidebarTrigger className="h-10 w-10 border border-border bg-muted/60 hover:bg-accent text-foreground rounded-md shadow-sm shrink-0" />
              <div className="flex items-center gap-2.5 min-w-0">
                <img src={logoAsset.url} alt="Indur Study Circle logo" className="w-9 h-9 rounded-md object-contain shrink-0" />
                <span className="text-base font-semibold text-foreground truncate">Indur Study Circle</span>
              </div>
              <div className="ml-auto flex items-center gap-1 shrink-0">
                <NotificationBell />
                <DarkModeToggle />
              </div>
            </div>
          </header>
          <main className="flex-1 min-h-0 overflow-y-auto overscroll-contain"><Suspense fallback={<div className="p-4 space-y-3"><div className="h-24 rounded-xl bg-muted/40 animate-pulse" /><div className="h-40 rounded-xl bg-muted/30 animate-pulse" /></div>}><PageGate>{children}</PageGate></Suspense></main>
          {!hideBottomNav && <BottomNav />}
          <PopupQuiz />
        </div>
      </div>
    </SidebarProvider>
  );
}
